export enum SiteType {
  RENTALP = "rentalp",
  SEASONALP = "seasonalp",
  HOMEALP = "homealp"
}
